// The Main Site Object
window.Site = {

    // Mobile Navigation Items
    mobileNavButton    : document.querySelector('.mobile-navigation-button'),
    mobileNavContainer : document.querySelector('.mobile-navigation'),

    // Mobile Nav Contacts Items
    mobileNavContactsButton : document.querySelector('button.mobile-navigation-link'),

    // Init Function
    liftoff : () => {
        Site.toggleMobileMenu()
        Site.showHideMobileContacts()
    },

    // Toggle the navigation on click
    toggleMobileMenu : () => {
        Site.mobileNavButton.addEventListener('click', () => {

            if (document.body.classList.contains('mobile-menu-is-open')) {
                document.body.classList.remove('mobile-menu-is-open','mobile-menu-contacts-are-visible')
            } else {
                document.body.classList.add('mobile-menu-is-open')
            }
        })
    },

    // Show hide the contacts inside the mobile navigation on tap
    showHideMobileContacts : () => {
        Site.mobileNavContactsButton.addEventListener('click', () => {
            document.body.classList.toggle('mobile-menu-contacts-are-visible')
        })
    }

}

// Launch The Script
Site.liftoff()